import { createFileRoute } from '@tanstack/react-router'
import { Page, PageHeader } from '@/components/shell'
import { CommunityProfilesPanel } from './-community-profiles'

export const Route = createFileRoute('/dashboard/meta-proposals')({
  component: MetaProposalsPage,
})

function MetaProposalsPage() {
  return (
    <Page>
      <PageHeader title="社区资料审核" description="审核站内资料维护申请，处理争议与发布异常。" />
      <CommunityProfilesPanel />
    </Page>
  )
}
